import { initialMapSettings } from '../Settings'
import { SIGNUP_MODAL } from 'common/modals/SignupModal'
import { LOGIN_MODAL_OVERLAY } from 'common/styleguide/LoginModalOverlay'
import { trackEvent } from 'lib/trackEvent'
import { uuid } from 'lib/utils'
import { showModal } from 'lib/modalUtils'

// NOTE about clickActionCommand: historically, this state was initially set
// via `selectedCommand`, which was determined from the
// route_planner_follow_roads user preference.  however, as of october 2020,
// this preference is not sticky in the new route planner, and according to
// https://github.com/ridewithgps/ridewithgps/blob/8051853bfd699a656d99e5e15c57b60ce4544519/public/javascripts/routes/new.js#L1474
// should be removed. (further, this pref isn't set anywhere in either codebase)
export const initialState = {
  leftCollapse: false,
  rightCollapse: false,
  sgCollapse: false,
  showCueReview: false,
  cueReviewKey: undefined,
  showRouteSplitter: false,
  showTraceTool: false,
  showSave: false,
  showSignup: false,
  distanceMarkersWas: null,
  mapSettings: initialMapSettings,
  clickActionCommand: 'followRoads',
  hoveredFeature: null,
  selectedFeature: null
}

export const reducer = (state, action) => {
  const { value } = action
  switch (action.type) {
    case 'setShowCueReview':
      return action.value
        ? {
          ...state,
          showCueReview: true,
          cueReviewKey: uuid(),
          distanceMarkersWas: state.mapSettings.showDistanceMarkers,
          mapSettings: { ...state.mapSettings, showDistanceMarkers: false }
        }
        : {
          ...state,
          showCueReview: false,
          mapSettings: { ...state.mapSettings, showDistanceMarkers: state.distanceMarkersWas },
          distanceMarkersWas: undefined
        }
    case 'forceRerenderCueReview':
      return { ...state, cueReviewKey: uuid() }
    case 'setShowRouteSplitter':
      return { ...state, showRouteSplitter: action.value }
    case 'setShowTraceTool':
      return { ...state, showTraceTool: action.value }
    case 'setShowSave':
      if (state.showSave === value) return state
      return {
        ...state,
        showSave: value,
        leftCollapse: value,
        rightCollapse: value,
        sgCollapse: value
      }
    case 'setShowSignup':
      if (state.showSignup === value) return state
      showModal(SIGNUP_MODAL, { onRequestLogin: () => showModal(LOGIN_MODAL_OVERLAY) })
      return { ...state, showSignup: value }
    case 'toggleLeft':
      trackEvent('Route Planner', 'Collapse left panel')
      return { ...state, leftCollapse: !state.leftCollapse }
    case 'toggleRight':
      trackEvent('Route Planner', 'Collapse right panel')
      return { ...state, rightCollapse: !state.rightCollapse }
    case 'setSgCollapse':
      return { ...state, sgCollapse: value }
    case 'setMapSettings':
      return { ...state, mapSettings: value }
    case 'setClickActionCommand':
      return { ...state, clickActionCommand: value }
    case 'setHoveredFeature':
      return { ...state, hoveredFeature: value }
    case 'setSelectedFeature':
      return { ...state, selectedFeature: value }
    default:
      return state
  }
}

export const actions = {
  setShowCueReview: (value, opts) => ({ type: 'setShowCueReview', value, opts }),
  forceRerenderCueReview: { type: 'forceRerenderCueReview' },
  setShowRouteSplitter: value => ({ type: 'setShowRouteSplitter', value }),
  setShowTraceTool: value => ({ type: 'setShowTraceTool', value }),
  setShowSave: value => ({ type: 'setShowSave', value }),
  setShowSignup: value => ({ type: 'setShowSignup', value }),
  toggleLeft: { type: 'toggleLeft' },
  toggleRight: { type: 'toggleRight' },
  setSgCollapse: value => ({ type: 'setSgCollapse', value }),
  setMapSettings: value => ({ type: 'setMapSettings', value }),
  setClickActionCommand: value => ({ type: 'setClickActionCommand', value }),
  setHoveredFeature: value => ({ type: 'setHoveredFeature', value }),
  setSelectedFeature: value => ({ type: 'setSelectedFeature', value })
}
